import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const FinalCTA = () => {
  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-slate-900 relative overflow-hidden">
      {/* Decorative orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-orange-500/30 to-pink-500/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-pink-500/30 to-orange-400/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
          Reservá tu lugar
        </h2>
        <p className="text-lg text-slate-300 mb-10">
          No te pierdas el encuentro más importante del canal de tecnología en Argentina.
        </p>
        <Button
          onClick={scrollToForm}
          size="lg"
          className="bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 text-white px-10 py-7 text-lg rounded-full transition-all duration-300 hover:scale-105 hover:shadow-2xl group"
        >
          Registrarme
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;
